import React, {useEffect, useState} from 'react';
import {getSingleDesignVariant} from "../../services/design-variant-data-service";
import _ from "lodash";
import {STAGE_ZOOM_STEP} from "../../constants/design.constant";
import {Layer, Rect, Stage} from "react-konva";
import TextPathShape from "../design-editor/konva-editor/text-path-shape";
import TextShape from "../design-editor/konva-editor/text-shape";
import RectangleShape from "../design-editor/konva-editor/rectangle-shape";
import ImageShape from "../design-editor/konva-editor/image-shape";
import {ArrowDownOnSquareIcon, EyeIcon, EyeSlashIcon, ArrowPathIcon, MagnifyingGlassPlusIcon, MagnifyingGlassMinusIcon} from "@heroicons/react/24/solid";
import UpdateDesignVariantStatus from "../common/update-design-variant-status";
import BackgroundRectangleShape from "../design-editor/konva-editor/background-rectangle-shape";
import BackgroundImageItem from "../design-editor/konva-editor/background-image-shape";


function downloadURI(uri, name) {
    let link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const PreviewDesignVariant = ({designVariantDetail, productColor, downloadAllVariants, selectedVariant}) => {
    const stageRef = React.useRef(null);
    const layerRef = React.useRef(null);
    const backgroundRef = React.useRef(null);
    const [stagePos, setStagePos] = useState(null);
    const [stageScale, setStageScale] = useState(1);
    const [stageDimension, setStageDimension] = useState(null);
    const [showStage, setShowStage] = useState(false);
    const [stageScalePercentage, setStageScalePercentage] = useState(100);
    const [showTemplates, setShowTemplates] = useState(true);

    useEffect(() => {
        if (designVariantDetail) {
            const existingDesignVariantDetail = {...designVariantDetail};
            initStage(existingDesignVariantDetail);
        }
    }, [designVariantDetail]);

    /*useEffect(() => {
        if (downloadAllVariants) {
            handleExport();
        }
    }, [downloadAllVariants]);*/

    useEffect(() => {
        if (designVariantDetail) {
            let currentStageScale = _.parseInt((stageScale * 100).toString());
            setStageScalePercentage(currentStageScale);
        }
    }, [stageScale])

    const initStage = (existingDesignVariantDetail) => {
        const settings = existingDesignVariantDetail.settings;

        fitStageIntoParentContainer(settings);
        setShowStage(true);

        refreshStage(true);
    }

    const fitStageIntoParentContainer = (settings) => {
        const stage = stageRef.current;
        let container = document.querySelector('#stage-parent');
        // @ts-ignore
        let containerWidth = container.offsetWidth * 0.75;
        let scale = containerWidth / settings?.width;

        setStageScale(scale);

        stage.width(settings?.width * scale);
        stage.height(settings?.height * scale);
        stage.scale({x: scale, y: scale});

        setStageDimension({height: stage?.height(), width: stage?.width()});
    }

    const refreshStage = (triggerDownloadImage?) => {
        setTimeout(() => {
            const stage = stageRef.current;
            stage.draw();

            if (triggerDownloadImage && downloadAllVariants) {
                handleExport();
            }
        }, 100);
    }

    const handleExport = () => {
        showTemplateImages(false);
        
        const pixelRatio = 100 / (stageScale * 100);
        const uri = stageRef.current.toDataURL({
            pixelRatio: pixelRatio
        });

        showTemplateImages(true);
        downloadURI(uri, designVariantDetail.imageFileName);
    };

    const showTemplateImages = (showOrHide) => {
        setShowTemplates(showOrHide);
        const stage = stageRef.current;
        const templateImages = stage.find('.template-image');
        _.forEach(templateImages, templateImage => {
            templateImage.visible(showOrHide);
        });
    }

    const zoomIn = () => {
        let currentStageScale = stageScale;
        currentStageScale += STAGE_ZOOM_STEP;

        setStageScale(currentStageScale);
        changeStageScale(currentStageScale);
    }

    const zoomOut = () => {
        let currentStageScale = stageScale;
        currentStageScale -= STAGE_ZOOM_STEP;

        setStageScale(currentStageScale);
        changeStageScale(currentStageScale);
    }

    const changeStageScale = (scale) => {
        const stage = stageRef.current;
        const existingDesignVariantDetail = {...designVariantDetail};
        const settings = existingDesignVariantDetail.settings;

        stage.width(settings.width * scale);
        stage.height(settings.height * scale);
        stage.scale({x: scale, y: scale});

        refreshStage();
    }

    const toggleShowTemplates = (e) => {
        showTemplateImages(!showTemplates);
    }

    return (
        <>

            <div className="sticky top-0 left-0 bg-gray-400 z-40 py-2 px-2 rounded-t flex justify-between items-center">

                <div className="flex justify-between items-center">
                    <button onClick={zoomOut}
                            className="rounded flex items-center justify-center border bg-gray-100 text-gray-500 border-gray-500 hover:text-gray-700 hover:bg-white hover:border-gray-500">
                        <div className="p-2">
                            <MagnifyingGlassMinusIcon className="h-6 w-6"/>
                        </div>
                    </button>

                    <button
                        className="rounded flex items-center justify-center border bg-gray-100 text-gray-500 border-gray-500 hover:text-gray-700 hover:bg-white hover:border-gray-500 py-2 px-3 ml-2">
                        <div className="font-bold text-gray-600">{stageScalePercentage} %</div>
                    </button>

                    <button onClick={zoomIn}
                            className="rounded flex items-center justify-center border bg-gray-100 text-gray-500 border-gray-500 hover:text-gray-700 hover:bg-white hover:border-gray-500 ml-2">
                        <div className="p-2">
                            <MagnifyingGlassPlusIcon className="h-6 w-6"/>
                        </div>
                    </button>
                </div>

                <div className="flex justify-between items-center">
                    <button onClick={refreshStage}
                            className="rounded flex items-center justify-center border bg-gray-100 text-gray-500 border-gray-500 hover:text-gray-700 hover:bg-white hover:border-gray-500">
                        <div className="p-2">
                            <ArrowPathIcon className="h-6 w-6"/>
                        </div>
                    </button>

                    <button onClick={toggleShowTemplates}
                            className="rounded flex items-center justify-center border bg-gray-100 text-gray-500 border-gray-500 hover:text-gray-700 hover:bg-white hover:border-gray-500 ml-2">
                        {showTemplates &&
                            <div className="p-2">
                                <EyeIcon className="h-6 w-6"/>
                            </div>
                        }

                        {!showTemplates &&
                            <div className="p-2">
                                <EyeSlashIcon className="h-6 w-6"/>
                            </div>
                        }
                    </button>

                    {productColor &&
                        <div className="flex justify-start items-center ml-2">
                            <div style={{'backgroundColor': `${productColor?.code}`}}
                                 className={`m-1 border border-gray-500 px-3 py-2 rounded flex justify-center
                                ${productColor?.code ? 'text-white' : 'bg-gray-200 text-black'} ${productColor?.name === 'White' ? 'bg-white text-black' : ''}`}>
                                <div className="self-center">{productColor?.name}</div>
                            </div>
                        </div>
                    }
                </div>

                <div className="flex justify-center mr-4">

                    {/*<UpdateDesignVariantStatus
                        designVariant={designVariantDetail}
                        markAsPublished={undefined}
                        markAsReadyToPublish={handleMarkAsReadyToPublish}
                        markAsInDesign={undefined}
                        downloadInProgress={undefined}/>*/}

                    <button onClick={handleExport}
                            className="button-green py-2 px-3 flex justify-center ml-2">
                        <div className="pr-2">
                            <ArrowDownOnSquareIcon className="h-6 w-6"/>
                        </div>
                        Download
                    </button>
                </div>
            </div>

            <div
                className="preview-design-variant-container overflow-scroll w-full border border-gray-500 border border-gray-300 rounded-b bg-gray-100">

                <div id="stage-parent"
                     className="flex justify-center px-4 pt-8 pb-4">

                    <Stage width={stageDimension?.width} height={stageDimension?.height}
                           style={{'backgroundColor': productColor ? productColor?.code : '#FFFFFF'}}
                           className="flex justify-start border border-gray-800 shadow-lg"
                           draggable={false}
                           listening={false}
                           perfectDrawEnabled={false}
                           ref={stageRef}
                           scaleX={stageScale}
                           scaleY={stageScale}
                           x={stagePos?.x}
                           y={stagePos?.y}>

                        {showStage &&

                            <>

                                <Layer>
                                    <BackgroundRectangleShape
                                        backgroundRef={backgroundRef}
                                        background={designVariantDetail?.settings?.background}
                                        stageWidth={designVariantDetail?.settings?.width}
                                        stageHeight={designVariantDetail?.settings?.height}/>
                                </Layer>

                                <Layer>
                                    {designVariantDetail?.images?.map((imageDetail, index) => {
                                        return <BackgroundImageItem
                                            key={`repeat-image-${index}-${imageDetail.key}`}
                                            stageWidth={designVariantDetail?.settings?.width}
                                            stageHeight={designVariantDetail?.settings?.height}
                                            backgroundImage={imageDetail}
                                            settings={designVariantDetail?.settings}/>

                                    })}
                                </Layer>

                                <Layer ref={layerRef}>

                                    {designVariantDetail?.images?.map((imageDetail, index) => {
                                        return <ImageShape
                                            key={`image-${index}-${imageDetail.key}`}
                                            shapeProps={imageDetail}
                                            isSelected={false}
                                            onSelect={undefined}
                                            onChange={undefined}
                                            handleGuidelineDragEnd={undefined}
                                            handleGuidelineDragMove={undefined}
                                        />
                                    })}

                                    {designVariantDetail?.shapes?.map((shapeDetail, index) => {
                                        return <RectangleShape
                                            key={shapeDetail?.key}
                                            shapeProps={shapeDetail}
                                            onChange={undefined}
                                            handleGuidelineDragEnd={undefined}
                                            handleGuidelineDragMove={undefined}/>
                                    })}

                                    {!designVariantDetail?.settings?.noText &&
                                        <>
                                            {designVariantDetail?.textItems?.map((textItem, index) => {
                                                return textItem?.radius ? <TextPathShape
                                                    key={textItem?.key}
                                                    shapeProps={textItem}
                                                    isSelected={false}
                                                    onSelect={undefined}
                                                    onChange={undefined}
                                                    transformerRef={undefined}
                                                    handleGuidelineDragEnd={undefined}
                                                    handleGuidelineDragMove={undefined}
                                                /> : <TextShape
                                                    key={textItem?.key}
                                                    shapeProps={textItem}
                                                    isSelected={false}
                                                    onSelect={undefined}
                                                    onChange={undefined}
                                                    stagePos={stagePos}
                                                    transformerRef={undefined}
                                                    handleGuidelineDragEnd={undefined}
                                                    handleGuidelineDragMove={undefined}
                                                />

                                            })}
                                        </>
                                    }

                                </Layer>

                            </>

                        }


                    </Stage>

                </div>
            </div>

        </>
    )
}

export default PreviewDesignVariant
